import { z } from 'zod';

export const updateArticleParamsSchema = z.object({
  article_id: z.uuid('Invalid article ID'),
});

export const updateArticleSchema = z.object({
  title: z.string().min(1, 'Title is required').max(255, 'Title must be less than 255 characters').optional(),
  description: z.string().min(1, 'Description is required').optional(),
  content: z.string().min(1, 'Content is required').optional(),
  image_url: z.string().optional(),
  image: z.instanceof(File).optional(),
  is_published: z.preprocess((val) => val === 'true' || val === true, z.boolean()).optional(),
});

export type UpdateArticleParamsPayload = z.infer<typeof updateArticleParamsSchema>;
export type UpdateArticlePayload = z.infer<typeof updateArticleSchema>;
